// 登录
<template>
  <div ref="contentBox" class="content-box" :class="bgTag?'content-box1':''">
    <div class="login-page-box">
      <div class="project-title">
        <span>繁星数据管理平台</span>
      </div>
      <div class="login-box">
        <ul>
          <li class="phone-box">
            <div class="input-content clearfix">
              <el-input v-model="phone" placeholder="手机号码">
                <i slot="prefix" class="iconfont iconshouji"></i>
              </el-input>
            </div>
          </li>
          <li class="psd-box">
            <div class="input-content clearfix">
              <el-input v-model="psd" type="password" placeholder="密码">
                <i slot="prefix" class="iconfont iconyanzhengma"></i>
              </el-input>
            </div>
          </li>
        </ul>
        <div class="login-other-info clearfix">
          <p class="tips">{{tips}}</p>
        </div>
        <div class="login-btn" @click="selectFun()">
          <el-button type="primary" :disabled='isClick'>登录</el-button>
        </div>
      </div>
    </div>
    <div class="footer">
      <a href="http://www.beian.miit.gov.cn" target="_black">京ICP备18044594号-1&nbsp;&nbsp;&nbsp;版权所有©北京道口金科科技有限公司</a>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
export default {
  name: 'Login',
  data () {
    return {
      phone:'',
      psd:'',
      isClick:true,
      tips:'',
      bgTag:false,
    }
  },
  mounted () {
    var _this=this;
    this.$refs.contentBox.style.height = window.innerHeight +'px' ;
    var heightWindow=window.innerHeight;
    var widthWindow=window.innerWidth;
    if((widthWindow/heightWindow)<=(1928/1080)){
      _this.bgTag=true;
    }else{
      _this.bgTag=false;
    }
  },
 
  methods:{
    ...mapMutations(['changeLogin']),
    selectFun:function(){
      var _this=this;
      if(this.$common.testPhone(_this.phone) && _this.psd!=''){
        var terms=new Object();
        terms.userPhone=_this.phone;
        terms.userPassword=_this.psd;
        this.$axios.post('/requestApi/login',terms)
          .then(function(response){
            let data = response.data;
            if(data.meta.retCode==0){
              _this.changeLogin({ Authorization: data.data.token});
              var UserInfoStr=Base64.decode(data.data.token.split('.')[1]);
              localStorage.setItem('UserInfo',UserInfoStr);
              _this.$router.push({ path: '/' });
            }else{
              _this.tips=data.meta.friendlyMsg;
            }
          })
          .catch(function(error){
            console.log(error)
          });
      }
    },
  },
  watch: {
    phone: {
      handler: function (val) {
        var _this=this;
        if(!this.$common.testPhone(_this.phone)){
          _this.tips='请检查输入手机号';
        };
        if(this.$common.testPhone(_this.phone) && _this.psd==''){
          _this.tips='请输入密码';
        };
        if(this.$common.testPhone(_this.phone) && _this.psd!=''){
          _this.isClick=false;
          _this.tips='';
        }else{
          _this.isClick=true;
        }
      },
      deep: true
    },
    psd: {
      handler: function (val) {
        var _this=this;
        if(!this.$common.testPhone(_this.phone)){
          _this.tips='请检查输入手机号';
        };
        if(this.$common.testPhone(_this.phone) && _this.psd==''){
          _this.tips='请输入密码';
        };
        if(this.$common.testPhone(_this.phone) && _this.psd!=''){
          _this.isClick=false;
          _this.tips='';
        }else{
          _this.isClick=true;
        }
      },
      deep: true
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content-box{padding: 0;margin: 0px; width: 100%; position: absolute; top:0%;left: 0%; background: url('/static/images/login-bg.png') no-repeat center center;background-size: 100% auto;}
.content-box1{background-size: auto 100%;}
.project-title{width: 100%; padding-top: 60px;}
.project-title span{display: inline-block; font-weight: 600; font-size: 36px; line-height: 40px; height: 40px; color: #333;width: 100%;}
.login-box{width: 100%;margin-top: 80px;}
.login-box ul li{margin-bottom: 24px;}
.login-btn{width: 182px;height: 54px; margin-top: 56px;}
.login-btn button{width: 100%;border-radius: 27px; height: 100%;line-height: 100%;color: #fff;font-size: 18px;padding: 0px;}
.login-page-box{width: 480px;position: absolute;top:20%;left: 15%;}
.login-other-info{width: 100%;}
.tips{display: block;float: left;line-height: 22px;color: #E02020;font-size: 14px;}
.login-box ul .psd-box{margin-bottom: 10px;}
.forget-psd{display: block; float: right; width: 80px;height: 22px;line-height: 22px;text-align: right;font-size: 16px; color: #666;}
.psd-footer-btn{display: block;width: 100%;height: 46px;line-height: 46px;background-color: #3377FF;text-align: center;border-radius: 4px; font-size: 16px;color: #fff;}
.get-pic-code{border-left: 1px solid #DCDFE6;display: inline-block;height: 30px;padding: 0px 6px; margin-left: -4px;}
.get-pic-code i{font-size: 20px;line-height: 30px;}
.get-msg-code{display: inline-block;height: 30px; line-height: 30px; padding: 0px 6px; color: #3377FF;}
/* .dialog-content .tips{width: 100%;height: 22px;} */
.iconfont{line-height: 54px;color: #888;}
.footer{position: absolute;left: 0%;bottom: 20px;  width: 100%;}
.footer a{display: block;width: 100%;text-align: center; font-size: 12px;color: #666;line-height: 20px;}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue